import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { CollapseComponent } from './components/expand-collapse/expand-collapse.component';
import { SharedPipesModule } from '../shared/pipes/shared-pipes.module';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.components';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { PageTitleComponent } from './components/page-title/page-title.component';
import { AlertComponent } from './modals/alert/alert.component';
import { AlertService } from './modals/alert/alert.service';
import { ErrorModalComponent } from './modals/error-modal/error-modal.component';
import { ErrorModalService } from './modals/error-modal/error-modal.service';
import { LoadingComponent } from './modals/loading/loading.component';
import { LoadingService } from './modals/loading/loading.service';
import { PageNavLoaderComponent } from './modals/page-nav-loader/page-nav-loader.component';
import { ModalPopupComponent } from './modals/popup-modal/popup-modal.component';
import { SessionModalComponent } from './modals/session-modal/session-modal.component';
import { NavigationTilesComponent } from './components/navigation-tiles/navigation-tiles.component';
import { AllowedAccessDirective } from './directives/allowed-access.directive';
import { RouterModule } from '@angular/router';
import { UploadMeasurementsModalComponent } from './modals/admin/upload-measurements-modal/upload-measurements-modal.component';
import { FileUploadDirective } from './directives/file-upload.directive';
import { ToastComponent } from './components/toast/toast.component';
import { InputValidationComponent } from './components/input-validation/input-validation.component';
import { CreateCastMemberModalComponent } from './modals/admin/create-cast-member-modal/create-cast-member-modal.component';
import { CreateCharacterModalComponent } from './modals/admin/create-character-modal/create-character-modal.component';
import { HasRequiredFieldDirective } from './directives/has-required-field.directive';
import { ConfirmCancelModalComponent } from './modals/admin/confirm-cancel-modal/confirm-cancel-modal.component';
import { CreateCommentModalComponent } from './modals/admin/create-comment-modal/create-comment-modal.component';

// WDPR Imports
import '@wdpr/toast';
import '@wdpr/button';

const exportableComponents = [
  BreadcrumbsComponent,
  PageHeaderComponent,
  CollapseComponent,
  ModalPopupComponent,
  NavigationTilesComponent,
  SessionModalComponent
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    TranslateModule,
    TypeaheadModule,
    PopoverModule,
    SharedPipesModule,
    RouterModule
  ],
  declarations: [
    AlertComponent,
    CreateCommentModalComponent,
    ErrorModalComponent,
    LoadingComponent,
    PageNavLoaderComponent,
    PageTitleComponent,
    exportableComponents,
    AllowedAccessDirective,
    UploadMeasurementsModalComponent,
    FileUploadDirective,
    ToastComponent,
    InputValidationComponent,
    CreateCastMemberModalComponent,
    CreateCharacterModalComponent,
    HasRequiredFieldDirective,
    ConfirmCancelModalComponent
  ],
  exports: [
    AlertComponent,
    CreateCommentModalComponent,
    CommonModule,
    ErrorModalComponent,
    LoadingComponent,
    ReactiveFormsModule,
    PageNavLoaderComponent,
    PageTitleComponent,
    exportableComponents,
    AllowedAccessDirective,
    UploadMeasurementsModalComponent,
    ToastComponent,
    InputValidationComponent,
    CreateCastMemberModalComponent,
    CreateCharacterModalComponent,
    HasRequiredFieldDirective,
    ConfirmCancelModalComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {
  static forRoot() {
    return {
      ngModule: SharedModule,
      providers: [
        AlertService,
        ErrorModalService,
        LoadingService,
      ],
    };
  }
}
